<template>
    <b-form :save-url="addUrl" @success="formSuccess" v-slot="{model, loading}" :save-params="{course, location}">
        <div class="row">
            <div class="col-12">
                <validated-input label="Name" v-model="model.name"
                                 :rules="{required: true, max:50}" :disabled="loading"/>
            </div>
            <div class="col-12">
                <validated-input label="Designation" v-model="model.designation"
                                 :rules="{required: false}" :disabled="loading"/>
            </div>
            <div class="col-12">
                <validated-text-area label="Description" v-model="model.description"
                                     :rules="{required: true, max:1000}" :disabled="loading"/>
            </div>
            <div class="col-12 text-right">
                <btn class="trn" text="Save" loading-text="Saving..." size="sm" :disabled="loading" :loading="loading"/>
            </div>
        </div>
    </b-form>
</template>

<script>

import urls from '../../../../data/urls';

export default {
    props: {
        course: { type: String },
        location: { type: String }
    },
    name: 'AddCourseFaculty',

    data () {
        return {
            locationOption: urls.admin.trainingCenter.vueSelect,
            addUrl: urls.admin.course.detailsUrl.faculty.addEdit
        };
    },

    methods: {
        formSuccess () {
            this.$notify('Successfully Added Item..!', 'Success',
                {
                    type: 'success'
                }
            );
            this.$emit('success');
        }
    }
};
</script>

<style scoped>

</style>
